import { useContainer } from "./useContainer"

export const useLogout = () => useContainer().logoutService
